<div class="menu" *ngIf="Heading">
  <span class="menu-heading">{{ Heading }}</span>
  <span class="close" (click)="closeTaskSelectionMenu()">X</span>
</div>
<!-- <div class="cst-btnAddNewUser" *ngIf="searchType === 'user'">
  <input class="main-btn" *ngIf="enableAddNewBtn" type="submit" value="Not Found/Add New" (click)="addNewUser()" />
</div> -->
<div class="search-dialog-container">
  <div class="mt-3" style="display: flex" *ngFor="let count of addSearchParameterArray; let i = index">
    <div class="info search-box pt-2" *ngIf="i === 0; else elsePart">Find user by:</div>
    <ng-template #elsePart>
      <div class="info pt-2">&nbsp;</div>
    </ng-template>

    <select
      name="search-parameter"
      [(ngModel)]="addSearchParameterArray[i].type"
      (ngModelChange)="resetSearchParameter(i, $event)"
      id="search-parameter"
      class="search-box"
    >
      <ng-container *ngFor="let search of searchParams">        
        <option [ngValue]="search.Value">{{ search.Label }}</option>
      </ng-container>
    </select>
    <div class="container">
      <input type="text" (keydown.enter)="isSearchTriggered = true; searchRecords(null)" [(ngModel)]="addSearchParameterArray[i].value" class="search-input" style="width: 88%" />
      <button 
        *ngIf="i === 0; else elsePart2"
        class="search-btn"
        (click)="isSearchTriggered = true; searchRecords(null)"
      >
        <img alt="" class="search-img" src="{{ baseHref }}/assets/images/icon-search.svg" />
      </button>
      <ng-template #elsePart2>
        <button class="search-btn remove" (click)="removeSearchParameter()">X</button>
      </ng-template>
    </div>

    <!-- <input
      class="main-btn"
      type="submit"
      value="Go Back"
      (click)="goBack()"
      style="margin-left: auto"
      *ngIf="(countData == 1 || this.searchResult?.Response?.Data?.length == 1) && i == 0"
    /> -->
    <!-- *ngIf="(countData == 1 || this.searchResult?.Response?.Data?.length == 1) && i == 0" -->
    <!-- (click)="getCaseDetails()" -->
    <button
      *ngIf="!hideUnknownNewbtn && (addUserRequired && enableAddNewBtn && i === 0)"
      (click)="addNewUser()"
      class="add-param-btn add-new-btn ms-3 ps-2"
      [disabled]="userID"
    >
      Not Found? Add New
    </button>
    <button
      *ngIf="searchResult?.Response?.Data?.length && i === 0 &&!(isEmail && queueServices.getEmailComposeToValue())"
      (click)="onContinue()"
      class="main-btn large"
      style="margin-left: auto"
      [disabled]="searchResult?.Response?.Data?.length == 0">
      <!-- *ngIf="searchResult?.Response?.Data?.length && i === 0" -->
      <!-- [disabled]="selectedData == {} ? true : false" -->
      <!-- <span
        style="
          text-align: end;
          font-weight: 600;
          font-size: 0.813rem;
          line-height: 0.938rem;
          letter-spacing: 0rem;
          color: #000048;
        "
        > -->
      Continue
      <!-- </span> -->
    </button>
  </div>

  <div *ngIf="addSearchParameterArray">
    <button class="add-param-btn" (click)="addSearchParameter()">+ Add Search Parameter</button>
  </div>
</div>
<div class="search-details">
  <ng-container *ngIf="searchResult?.Response?.Data?.length">
    <!-- style="height: 18.75rem; display: grid" -->
    <app-search-dialog-details
      [searchType]="searchType"
      [isEmail]="isEmail"
      [searchData]="searchResult"
      [originalSearchResult]="originalSearchResult"
      (emitBackClicked)="backClicked($event)"
      (emitDataChange)="dataChange($event)"
    >
    </app-search-dialog-details>
  </ng-container>
  <!-- if search results array is empty -->
  <ng-container *ngIf="enableAddNewBtn">
    <div class="not-found-container">
      <img alt="" src="{{ baseHref }}/assets/images/icon-emoji-sad.svg" />
      No records found
    </div>
  </ng-container>
</div>
